import styled from '@emotion/styled';
import { Box, Button, DialogActions, IconButton, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import { LoadingButton } from '@mui/lab';

export const StyledDialogActions = styled(DialogActions)({
    padding: '0 1.5rem 1.5rem 1.5rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
});

export const FlexBox = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
});

export const StyledKeyboardArrowUpOutlinedIcon = styled(KeyboardArrowUpOutlinedIcon)({
    height: '1rem',
    position: 'absolute',
    cursor: 'pointer',
    marginTop: '0.125rem'
});

export const StyledKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)({
    height: '1rem',
    cursor: 'pointer',
    position: 'relative',
    top: '0.625rem'
});

export const KeyboardArrowContainer = styled(Typography)({
    position: 'relative',
    paddingTop: '0.125rem',
    fontWeight: 'bold',
    display: 'inline'
});

export const IconButtonContainer = styled(Typography)({
    position: 'relative',
    fontWeight: 'bold',
    display: 'inline',
    left: '-7px',
    top: '-4px'
});

export const IconButtonDown = styled(IconButton)({
    position: 'relative',
    top: '18px',
    padding: '3px'
});

export const IconButtonUp = styled(IconButton)({
    position: 'absolute',
    padding: '3px'
});

export const FlexCenterBox = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});

export const StyledCaseDetailsButtons = styled(Button)({
    borderRadius: '0.5rem',
    border: 1,
    marginRight: '0.625rem',
    marginTop: '0.6rem'
});

export const StyledCaseDetailsLoadingButton = styled(LoadingButton)({
    borderRadius: '0.5rem',
    border: 1,
    marginRight: '0.625rem',
    marginTop: '0.6rem'
});

export const BoldTextBox = styled(Box)({
    fontWeight: 'bold',
    marginBottom: '0.625rem'
});

export const SmallerTextBox = styled(Box)({
    fontSize: '0.813rem',
    marginBottom: '0.625rem',
    whiteSpace: 'pre-line',
    wordBreak: 'break-word'
});

export const SmallerBoldTextBox = styled(Box)({
    fontSize: '0.813rem',
    fontWeight: 'bold',
    marginBottom: '0.625rem'
});
